import { render } from "./TheTopMenuBar.vue?vue&type=template&id=c78a804e"
import script from "./TheTopMenuBar.vue?vue&type=script&lang=js"
export * from "./TheTopMenuBar.vue?vue&type=script&lang=js"

import "./TheTopMenuBar.vue?vue&type=style&index=0&id=c78a804e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__